<template>
  <div>
    <field-select-module
      title="작성자 정보"
      :board="this.board"
      :is-print="isPrint"
      v-model="form.stdInfo"
      :typeslabel="{ date: '등록일' }"
    />

    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 교육내용</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer">
        <div>
          <div>교육대상</div>
          <vs-select v-model="form.교육대상" autocomplete :readonly="board.readonly" placeholder="입력필드">
            <vs-select-item v-for="item in ['안전보건관리책임자', '안전관리자', '보건관리자']" :key="item" :value="item" :text="item" />
          </vs-select>
        </div>
        <div>
          <div>성명</div>
          <ml-input v-model="form.성명" :readonly="board.readonly" placeholder="입력필드" />
        </div>
        <div>
          <div>선임일</div>
          <date-selector class="w-full flex-1" v-model="form.선임일" :readonly="board.readonly" />
        </div>

        <div>
          <div>교육구분</div>
          <vs-select v-model="form.교육구분" autocomplete :readonly="board.readonly" placeholder="입력필드">
            <vs-select-item v-for="item in ['신규교육', '보수교육',]" :key="item" :value="item" :text="item" />
          </vs-select>
        </div>
        <div>
          <div>이수여부</div>
          <vs-select v-model="form.이수여부" autocomplete :readonly="board.readonly" placeholder="입력필드">
            <vs-select-item v-for="item in ['이수', '미이수']" :key="item" :value="item" :text="item" />
          </vs-select>
        </div>
        <div>
          <div>이수시간</div>
          <ml-input v-model="form.이수시간" :readonly="board.readonly" placeholder="입력필드" />
        </div>

        <div>
          <div>수료일자</div>
          <date-selector class="w-full flex-1" v-model="form.수료일자" :readonly="board.readonly" />
        </div>
        <div>
          <div>수료기관</div>
          <ml-input v-model="form.수료기관" :readonly="board.readonly" placeholder="입력필드" />
        </div>
        <div>
          <div>비고</div>
          <ml-input v-model="form.비고" :readonly="board.readonly" placeholder="입력필드" />
        </div>
      </div>

    </div>

    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>
<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule.vue";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";

export default {
  components: {
    FieldSelector, DateSelector,
    FileUploadModule,
    FieldSelectModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],

        "교육대상": '',
        "성명": '',
        "선임일": '',
        "교육구분": '',
        "이수여부": '',
        "이수시간": '',
        "수료일자": '',
        "수료기관": '',
        "비고": '',
      }
    };
  },
  methods: {
  }
};
</script>

<style scoped lang="scss"></style>
